module.exports = __webpack_public_path__ + "static/img/blackberry-m.a7ced2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/blackberry-m.jpg
// module id = iWn4
// module chunks = 0